import Barba from 'barba.js'
import $ from 'jquery'
import worksMenuToggle from 'modules/worksmenu'
//Progressive from

var Works = Barba.BaseView.extend({
    namespace: "works",
    onEnter: function() {
    },
    onEnterCompleted: function() {
        this._construct()
            $('body').addClass('js-works-open');
            $('.active').removeClass('active');
            $('.main-menu .js-works-trigger').addClass('active');
            $('html, body').animate({scrollTop : 0},800);
    },
    onLeave: function() {
        this.destroy()
    },
    $el: null,
    _construct: function() {
    },
    destroy: function() {

    }
});
export default Works;



// WEBPACK FOOTER //
// ./source/scripts/modules/barbaviews/works.js